import { CARE_PROFILE_SECTION_IDS } from "../../../utils/careProfileSections";

export const HOSPICE_PROFILE_SECTION_PROMPTS = {
  [CARE_PROFILE_SECTION_IDS.COMFORT_CARE]: [
    {
      title: "What signs of discomfort should caregivers watch for?",
      fields: [{
        type: "supportTag",
        key: "earlyWarningSigns",
        label: "Comfort changes or symptoms",
        optionsKey: "earlyWarningSigns",
        addText: "Add sign",
      }],
    },
    {
      title: "What usually brings comfort?",
      fields: [{
        type: "supportTag",
        key: "whatHelps",
        label: "Comfort supports",
        optionsKey: "whatHelps",
        addText: "Add comfort",
      }],
    },
    {
      title: "What can make symptoms or distress worse?",
      fields: [{
        type: "supportTag",
        key: "thingsToAvoid",
        label: "Things to avoid",
        optionsKey: "thingsToAvoid",
        addText: "Add avoid",
      }],
    },
    {
      title: "What symptom or comfort notes should the team know?",
      fields: [{
        type: "supportText",
        key: "communicationNotes",
        label: "Comfort and symptom notes",
        placeholder: "Pain signs, breathing changes, restlessness, anxiety, nausea, fatigue, or what feels normal for them.",
      }],
    },
  ],
  [CARE_PROFILE_SECTION_IDS.CARE_WISHES]: [
    {
      title: "What matters most to this person?",
      fields: [{
        type: "supportText",
        key: "about",
        label: "Care wishes and priorities",
        placeholder: "People, routines, music, faith, culture, privacy, surroundings, or anything that helps care feel respectful.",
      }],
    },
    {
      title: "What should caregivers protect or avoid?",
      fields: [{
        type: "supportTag",
        key: "thingsToAvoid",
        label: "Important things to avoid",
        optionsKey: "thingsToAvoid",
        addText: "Add avoid",
      }],
    },
    {
      title: "What guidance should family or care partners know?",
      fields: [{
        type: "supportTag",
        key: "familySupportTips",
        label: "Care guidance",
        optionsKey: "familySupportTips",
        addText: "Add guidance",
      }],
    },
  ],
  [CARE_PROFILE_SECTION_IDS.EMERGENCY_PROTOCOL]: [
    {
      title: "Who should caregivers call first?",
      fields: [{
        type: "supportText",
        key: "emergencyContacts",
        label: "Who to call",
        placeholder: "Hospice agency, nurse line, after-hours number, doctor, pharmacy, or backup family contact.",
      }],
    },
    {
      title: "When should caregivers call for help?",
      fields: [{
        type: "supportTag",
        key: "safetyConsiderations",
        label: "Call instructions and safety notes",
        optionsKey: "safetyConsiderations",
        addText: "Add instruction",
      }],
    },
  ],
  [CARE_PROFILE_SECTION_IDS.DAILY_COMFORT_ROUTINE]: [
    {
      title: "What daily comfort routines help?",
      fields: [{
        type: "supportTag",
        key: "whatHelps",
        label: "Daily comfort supports",
        optionsKey: "whatHelps",
        addText: "Add support",
      }],
    },
    {
      title: "How should caregivers communicate or approach care?",
      fields: [{
        type: "supportText",
        key: "communicationNotes",
        label: "Communication and approach notes",
        placeholder: "Speak softly, explain before touching or moving, limit visitors, use familiar music, or follow family wishes.",
      }],
    },
    {
      title: "What environment feels most calming?",
      fields: [{
        type: "supportText",
        key: "communicationNotes",
        label: "Comfort environment notes",
        placeholder: "Positioning, mouth care, skin care, lighting, noise, visitors, temperature, or rest preferences.",
      }],
    },
  ],
};
